module.exports = __webpack_public_path__ + "50f312c71d8ae608191b58c4af0a1f0b.MP3";